<template>
    <div>
        <tab-bar @on-pdf="handlerDownPdf"
                 @on-set="handlerToggleSet"
                 ref="tabBar"
                 :set="set"
                 :cs="rangeList.list"
                 :img="img"
                 :rt="rtable"/>
        <div class="wrapper-padding" v-show="!setShow">
            <div class="main-body">
                <div class="left-chart">
                    <echarts :zcb="jjfazcbMoney" :zsy="ntzhbMoney" />
                </div>
                <div class="right-table" ref="rightTable">
                    <table class="table">
                        <thead>
                        <tr>
                            <th>分类</th>
                            <th>项目</th>
                            <th>数值</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="bold" rowspan="3">人工投入</td>
                            <td>每年新车型试制投入时间（小时）</td>
                            <td v-active><span>{{mnxcxtrTime}}</span></td>
                        </tr>
                        <tr>
                            <td>每年节约试制时间（小时）</td>
                            <td v-active><span>{{mnjyszTime}}</span></td>
                        </tr>
                        <tr>
                            <td>每年人工投入节约（元）</td>
                            <td v-active><span>{{mnrgtrjyMoney}}</span></td>
                        </tr>
                        <tr>
                            <td class="bold" rowspan="2">返修成本</td>
                            <td>每年因拧紧问题导致的返修点数（个）</td>
                            <td v-active><span>{{mnynlswtdzfxdNumber}}</span></td>
                        </tr>
                        <tr>
                            <td>返修成本节约（元/年）</td>
                            <td v-active><span>{{fxcbjyMoney}}</span></td>
                        </tr>
                        <tr>
                            <td class="bold" rowspan="2">人工投入</td>
                            <td>每年试制数据档案建立所需工时（小时）</td>
                            <td v-active><span>{{mnszsjdajlsxTime}}</span></td>
                        </tr>
                        <tr>
                            <td>人工成本节约（元/年）</td>
                            <td v-active><span>{{rgjycbMoney}}</span></td>
                        </tr>
                        <tr>
                            <td class="bold">SQS产品成本</td>
                            <td>SQS解决方案总成本（元）</td>
                            <td v-active><span>{{jjfazcbMoney}}</span></td>
                        </tr>
                        </tbody>
                    </table>
                    <ul class="bottom-list">
                        <li>年投资回报（元）{{ntzhbMoney}}</li>
                        <li class="yellow">投资回报周期（月）{{tzhbzqTime}}</li>
                        <li>平均投资回报（元/次）{{pjtzhbMoney}}</li>
                    </ul>
                </div>
            </div>
            <div class="operate-wrapper">
                <span class="label">{{rangeList.list[rangeList.active].label}}</span>
                <div class="range">
                    <input :min="rangeList.list[rangeList.active].min"
                           :max="rangeList.list[rangeList.active].max"
                           v-model="range"
                           v-range
                           type="range">
                </div>
                <div class="inp">
                    <input type="number" v-model="range" class="input">
                </div>
            </div>
            <!--{{rangeList.list}}-->
            <ul class="select-wrapper">
                <li :class="{active: rangeList.active === key}"
                    v-for="(item, key) in rangeList.list"
                    @click="handlerTab(item, key)"
                    :key="key">
                    <i class="iconfont" :class="item.icon"></i>
                    <div>{{ item.name }}</div>
                </li>
            </ul>
        </div>
        <div class="none-echart">
            <echarts ref="Charts" :zcb="jjfazcbMoney" :zsy="ntzhbMoney"/>
        </div>
        <set-form v-model="setShow" :set-value="set" @on-ok="handlerOk"/>
    </div>
</template>

<script>
    import TabBar from '../../components/tab-bar'
    import Echarts from '../../components/ec-canvas'
    import SetForm from '../../components/set-form'
    import downpdf from '../../mixin/downpdf'

    export default {
        name: "Pilot",
        data() {
            return {
                setShow: false,
                range: 10,
                rangeList: {
                    active: 'trsj',
                    list: {
                        trsj: {
                            value: 10,
                            name: '投入时间减少',
                            min: 0,
                            max: 100,
                            icon: 'icon-gongzuoshijian',
                            label: '使用SQS解决方案后平均投入时间减少（%）',
                        },
                        fxds: {
                            value: 5,
                            name: '问题返修点数',
                            min: 0,
                            max: 30,
                            icon: 'icon-fanxiuchuli',
                            label: '平均每辆车因拧紧问题导致的返修点数（个）',
                        },
                        fxcs: {
                            value: 50,
                            name: '返修次数减少',
                            min: 0,
                            max: 100,
                            icon: 'icon-dingdanliebiao1',
                            label: '使用SQS解决方案后返修次数减少（%）',
                        },
                        sxgs: {
                            value: 2.5,
                            name: '数据记录工时',
                            min: 0,
                            max: 5,
                            icon: 'icon-gongshitongji',
                            label: '平均每辆车拧紧数据记录及分析所需工时（小时）',
                        },
                        jygs: {
                            value: 50,
                            name: '记录工时节约',
                            min: 0,
                            max: 100,
                            icon: 'icon-shijian',
                            label: '使用SQS解决方案后节约数据记录工时（%）',
                        },
                    }
                },
                set: {
                    szjbsj: {
                        name: '试制基本数据',
                        type: 'section-title'
                    },
                    xcpjsztrTime: {
                        name: '新车平均试制投入工时（小时 / 辆）',
                        value: 8,
                        type: 'input'
                    },
                    szzgscbMoney: {
                        name: '试制组工时成本（元 / 小时）',
                        value: 200,
                        type: 'input'
                    },
                    njszcwclNumber: {
                        name: '年均试制车完成量（辆）',
                        value: 300,
                        type: 'input'
                    },
                    szcbhgfxcbMoney: {
                        name: '试制车不合格点返修成本（元 / 个）',
                        value: 30,
                        type: 'input'
                    },
                    sjllyggscbMoney: {
                        name: '数据记录员工工时成本（元 / 小时）',
                        value: 100,
                        type: 'input'
                    },
                    ngzrNumber: {
                        name: '年工作日',
                        value: 200,
                        type: 'input'
                    },
                    cpcb: {
                        name: 'SQS产品成本',
                        type: 'section-title'
                    },
                    jjfaMoney: {
                        name: 'SQS产品解决方案（元）',
                        value: 150000,
                        type: 'input'
                    },
                    aztsMoney: {
                        name: '安装及调试成本（元）',
                        value: 50000,
                        type: 'input'
                    },
                }
            }
        },
        mixins: [downpdf],
        watch: {
            range: {
                handler(val) {
                    this.rangeList.list[this.rangeList.active].value = val
                },
                immediate: true
            }
        },
        computed: {
            // 投入时间
            trsj() {
                console.log(this.rangeList.list.trsj.value)
                return Number(this.rangeList.list.trsj.value) / 100
            },
            // 返修点数
            fxds() {
                return Number(this.rangeList.list.fxds.value)
            },
            // 返修次数
            fxcs() {
                return Number(this.rangeList.list.fxcs.value) / 100
            },
            // 所需工时
            sxgs() {
                return Number(this.rangeList.list.sxgs.value)
            },
            // 节约工时
            jygs() {
                return Number(this.rangeList.list.jygs.value) / 100
            },
            // 每年新车型试制投入时间（小时）
            mnxcxtrTime() {
                const a = Number(this.set.xcpjsztrTime.value)
                const b = Number(this.set.njszcwclNumber.value)
                return (a * b).toFixed(0)
            },
            // 每年节约试制时间（小时）
            mnjyszTime() {
                const a = Number(this.mnxcxtrTime)
                const b = Number(this.trsj)
                return (a * b).toFixed(0)
            },
            // 每年人工投入节约（元）
            mnrgtrjyMoney() {
                const a = Number(this.set.szzgscbMoney.value)
                const b = Number(this.mnjyszTime)
                return (a * b).toFixed(0)
            },
            // 每年因拧紧问题导致的返修点数（个）
            mnynlswtdzfxdNumber() {
                const a = Number(this.fxds)
                const b = Number(this.set.njszcwclNumber.value)
                return (a * b).toFixed(0)
            },
            // 返修成本节约（元/年）
            fxcbjyMoney() {
                const a = Number(this.mnynlswtdzfxdNumber)
                const b = Number(this.fxcs)
                const c = Number(this.set.szcbhgfxcbMoney.value)
                return (a * b * c).toFixed(0)
            },
            // 每年试制数据档案建立所需工时（小时）
            mnszsjdajlsxTime() {
                const a = Number(this.sxgs)
                const b = Number(this.set.njszcwclNumber.value)
                return (a * b).toFixed(0)
            },
            // 人工成本节约（元/年）
            rgjycbMoney() {
                const a = Number(this.mnszsjdajlsxTime)
                const b = Number(this.jygs)
                const c = Number(this.set.sjllyggscbMoney.value)
                return (a * b * c).toFixed(0)
            },
            // SQS解决方案总成本（元）
            jjfazcbMoney() {
                const a = Number(this.set.jjfaMoney.value)
                const b = Number(this.set.aztsMoney.value)
                return (a + b).toFixed(0)
            },
            // 年投资回报（元）
            ntzhbMoney() {
                const a = Number(this.mnrgtrjyMoney)
                const b = Number(this.fxcbjyMoney)
                const c = Number(this.rgjycbMoney)
                return (a + b + c).toFixed(0)
            },
            // 投资回报周期（月）
            tzhbzqTime() {
                const a = Number(this.jjfazcbMoney)
                const b = Number(this.ntzhbMoney)
                return (a / (b / 12)).toFixed(2)
            },
            // 平均投资回报（元/次）
            pjtzhbMoney() {
                const a = Number(this.ntzhbMoney)
                const b = Number(this.set.njszcwclNumber.value)
                return (a / b).toFixed(0)
            },
        },
        components: {TabBar, Echarts, SetForm},
        created() {
        },
        methods: {
            handlerToggleSet() {
                this.setShow = !this.setShow
            },
            handlerTab(item, key) {
                this.rangeList.active = key
                this.range = item.value
            },
            handlerOk(data) {
                this.set = data
            }
        },
    }
</script>

<style lang="scss">
    .chart-wrap {
        background-color: #f7f8fb;

        .right-table-wrap {

        }
    }
</style>
